module.exports = __webpack_public_path__ + "img/whats-new-desktop_en.c7f3753.jpg";